const statuses = {
    "Received": {
        "title": "Received",
        "message": "We have received your order and it is being processed.",
        "currentOrderMessage": "Your order is being received.",
        "progress": 25
    },
    "Preparing": {
        "title": "Preparing",
        "message": "Your order is being prepared by our kitchen team.",
        "currentOrderMessage": "Your order is being prepared by our kitchen team.",
        "progress": 50
    },
    "ReadyForPickup": {
        "title": "Ready For Pickup",
        "message": "Your order is ready for pickup.",
        "currentOrderMessage": "Your order is ready for pickup.",
        "progress": 75
    },
    "OrderPickedUp": {
        "title": "Order Picked Up",
        "message": "Your order has been picked up. Enjoy your meal!",
        "currentOrderMessage": "Your order has been picked up. Enjoy your meal!",
        "progress": 100
    },
    "Delivered": {
        "title": "Delivered",
        "message": "Your order has been delivered successfully.",
        "currentOrderMessage": "Your order has been delivered successfully.",
        "progress": 100
    },
    "Cancelled": {
        "title": "Cancelled",
        "message": "Your order has been cancelled.",
        "currentOrderMessage": "Your order has been cancelled.",
        "progress": 0
    },
    "Rejected": {
        "title": "Rejected",
        "message": "Your order has been rejected.",
        "currentOrderMessage": "Your order has been rejected.",
        "progress": 0
    },
    "CancelledByCustomer": {
        "title": "Cancelled By Customer",
        "message": "Your order has been cancelled by you.",
        "currentOrderMessage": "Your order has been cancelled by you.",
        "progress": 0
    }


}

export default statuses